import { TickCircle } from "iconsax-react";

export default function RequestSuccess() {
    return (
        <div className="h-[100svh] flex flex-col justify-center items-center">
            <TickCircle color="green" variant="Bold" size={46} />
            <div className="mt-2"></div>
            <div className="text-[20px] font-bold">Your account request has been sent successfully</div>
            <div className="text-[15px] text-gray-500">You would receive a follow up email once the process is complete</div>
        </div>
    )
}